import { render, staticRenderFns } from "./nested.vue?vue&type=template&id=11e8840a&scoped=true"
import script from "./nested.vue?vue&type=script&lang=js"
export * from "./nested.vue?vue&type=script&lang=js"
import style0 from "./nested.vue?vue&type=style&index=0&id=11e8840a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e8840a",
  null
  
)

export default component.exports